import {
  CloseMdIcon,
  IconButton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';
import { ListType } from 'crono-fe-common/types/list';
import useSearchLists from 'hooks/services/lists/useSearchLists';
import { forwardRef } from 'react';
import { cn } from 'utils/style-utils';
import { findTeamColor } from 'components/TeamsUsersSelect/utils';

const sizeConfig = {
  md: {
    containerClassName: 'gap-2 text-xs py-1 px-2',
  },
  sm: {
    containerClassName: 'gap-1 text-3xs py-0.5 px-1',
  },
};

interface TeamBadgeProps {
  className?: string;
  team: {
    id: number;
    name: string;
  };
  onRemove?: () => void;
  hideTooltip?: boolean;
  size?: 'sm' | 'md';
}

export const TeamBadge = forwardRef<HTMLDivElement, TeamBadgeProps>(
  (props, ref) => {
    const { className, team, hideTooltip, onRemove, size = 'md' } = props;
    const config = sizeConfig[size];

    const { data: teamsListData } = useSearchLists({
      type: ListType.User,
      sortType: 'Creation',
    });

    const teamIndex =
      teamsListData?.data.data.findIndex((t) => t.id === team.id) ?? 0;
    const dotColor = findTeamColor(teamIndex);

    return (
      <div
        ref={ref}
        className={cn(
          'flex items-center rounded-md bg-white border font-medium overflow-hidden max-w-36 shrink-0',
          config.containerClassName,
          className,
        )}
        style={{ borderColor: dotColor }}
      >
        <div
          className="size-2.5 shrink-0 rounded-full"
          style={{ background: dotColor }}
        />
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center gap-2 overflow-hidden">
              <span className="flex-1 truncate">{team.name}</span>
              {!!onRemove && (
                <IconButton
                  variant="ghost"
                  shape="circle"
                  size="xs"
                  label="Remove team"
                  icon={CloseMdIcon}
                  onClick={onRemove}
                />
              )}
            </div>
          </TooltipTrigger>

          {!hideTooltip && <TooltipContent>{team.name}</TooltipContent>}
        </Tooltip>
      </div>
    );
  },
);
